/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import t from "prop-types";
import { validatePackage as l, IconWrap as o } from "@progress/kendo-react-common";
import { chevronLeftIcon as d, chevronRightIcon as s } from "@progress/kendo-svg-icons";
import { packageMetadata as u } from "../package-metadata.mjs";
const m = r.forwardRef((e, c) => {
  l(u);
  const a = r.useRef(null), n = r.useRef(null);
  return r.useImperativeHandle(a, () => {
    var i;
    return {
      element: ((i = n.current) == null ? void 0 : i.element) || null,
      props: e
    };
  }), r.useImperativeHandle(c, () => a.current), /* @__PURE__ */ r.createElement(
    o,
    {
      ref: n,
      id: e.id,
      "aria-hidden": !0,
      tabIndex: e.tabIndex,
      style: e.style,
      name: e.dir === "rtl" ? "chevron-left" : "chevron-right",
      icon: e.dir === "rtl" ? d : s,
      className: "k-breadcrumb-delimiter-icon",
      size: "xsmall"
    }
  );
}), f = {
  id: t.string,
  className: t.string,
  style: t.object,
  tabIndex: t.number,
  dir: t.string
};
m.displayName = "KendoReactBreadcrumbDelimiter";
m.propTypes = f;
export {
  m as BreadcrumbDelimiter
};
